import type { IconSvgElement } from "@hugeicons/react"

export const gitHubIcon: IconSvgElement = [
  [
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor",
      d: "M11.963 0C5.35 0 0 5.387 0 12.055c0 5.324 3.428 9.82 8.185 11.417.594.12.812-.259.812-.578 0-.279-.02-1.237-.02-2.236-3.329.719-4.02-1.437-4.02-1.437-.535-1.397-1.328-1.755-1.328-1.755-1.089-.739.079-.739.079-.739 1.208.08 1.843 1.237 1.843 1.237 1.069 1.837 2.792 1.318 3.486.999.099-.779.416-1.318.753-1.618-2.653-.279-5.447-1.318-5.447-5.948 0-1.318.475-2.396 1.228-3.235-.119-.299-.535-1.537.119-3.193 0 0 1.01-.319 3.287 1.237a11.501 11.501 0 0 1 2.991-.399c1.01 0 2.04.14 2.99.399 2.278-1.556 3.288-1.237 3.288-1.237.654 1.656.238 2.894.119 3.193.773.839 1.228 1.917 1.228 3.235 0 4.63-2.792 5.649-5.467 5.948.436.379.812 1.098.812 2.236 0 1.618-.02 2.915-.02 3.314 0 .319.218.699.812.579 4.757-1.598 8.185-6.094 8.185-11.418C23.926 5.387 18.556 0 11.963 0z",
    },
  ],
]
